<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p20"><span><a href="#/Contents#rp20">CITRUS-TOMATO SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="49" src="images/45ref.jpg" width="25"/></span></p>
<p class="normal"><span><i>Orange and lemon juices add a refreshing tang to this easy tomato soup.</i></span></p>
<p class="make"><span>4 first-course servings</span></p>
<p class="hang"><span>2 tablespoons finely chopped onion</span></p>
<p class="hang"><span>1 cup each: reduced-sodium fat-free chicken broth, frozen orange juice concentrate</span></p>
<p class="hang"><span>1 quart reduced-sodium tomato juice</span></p>
<p class="hang"><span>2 tablespoons each: light brown sugar, lemon juice</span></p>
<p class="hang"><span>1–2 drops hot pepper sauce</span></p>
<p class="hang"><span>Salt, to taste</span></p>
<p class="hang"><span>Thin orange slices, as garnish</span></p>
<p class="normalt"><span><b>1.</b> Heat onion and broth to boiling in small saucepan; reduce heat and simmer, covered, until tender, about 5 minutes; transfer to bowl and add remaining ingredients, except salt and orange slices. Season to taste with salt; refrigerate until chilled. Garnish each bowl of soup with an orange slice.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 92</span></p>
<p class="per1"><span>% calories from fat: 1</span></p>
<p class="per1"><span>Protein (g): 2.9</span></p>
<p class="per1"><span>Carbohydrate (g): 21.9</span></p>
<p class="per1"><span>Fat (g): 0.2</span></p>
<p class="per1"><span>Saturated fat (g): 0</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 90</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.5</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter022.vue?7d2e84fe